export default __webpack_public_path__ + "static/media/vanguard.3dccab26.svg";